import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { LookupAlumnos } from '../Alumnos/LookupAlumnos';
import { LookupCarreras } from '../Carreras/LookupCarreras';
import * as alumnoCarreraService from '../../services/alumnoCarrera/alumnoCarreraService';
import {
  classifyAlumnoCarreraError,
  currentEnrollmentYear,
  isValidAnioInicioCarrera,
  toSaveAlumnoCarreraPayload,
} from '../../services/alumnoCarrera/alumnoCarreraDto';
import { ChevronLeftIcon } from '../common/mdPageIcons';

export class AddAlumnoCarrera extends Component {
  static displayName = AddAlumnoCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      tagData: [{ id: '', text: '' }],
      alumno: { alumnoDni: '', alumnoCodigo: 0, alumnoNombre: '' },
      anioInicio: currentEnrollmentYear(),
      showLookupStudent: false,
      showLookupCarreras: false,
    };
  }

  async componentDidMount() {
    await constantClass.canAccess('WWAlumnosxCarrera');
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.saveStudent();
    } else {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Los campos Alumno, Carrera y Año de inicio son obligatorios',
      });
    }
  };

  handleSelectStudentItem = (e) => {
    const studentProperties = e.split('%');
    this.setState({
      alumno: {
        alumnoDni: studentProperties[0],
        alumnoNombre: studentProperties[1],
        alumnoCodigo: studentProperties[2],
      },
      showLookupStudent: false,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    const tag = { id: carreraProperties[0], text: carreraProperties[1] };
    const tagData = this.state.tagData;
    tagData.push(tag);
    this.setState({ showLookupCarreras: false, tagData, showErrorMessage: false, errorMessage: '' });
  };

  handleAnioInicioChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
    this.setState({ anioInicio: digits, showErrorMessage: false, errorMessage: '' });
  };

  renderTags() {
    const tagData = this.state.tagData.slice(1);
    if (tagData.length === 0) {
      return <p className="md-page__file-hint">Ninguna carrera seleccionada</p>;
    }
    return (
      <ul className="md-page__tag-list">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-page__tag">
            <span>{tag.text}</span>
            {!this.state.loading ? (
              <button
                type="button"
                className="md-page__tag-remove"
                aria-label={'Quitar ' + tag.text}
                onClick={() => this.handleDelete(tag.id)}
              >
                ×
              </button>
            ) : null}
          </li>
        ))}
      </ul>
    );
  }

  handleShowStudentLookup = () => {
    this.setState({ showLookupStudent: true });
  };

  handleHideStudentLookup = () => {
    this.setState({ showLookupStudent: false });
  };

  handleHideCarreraLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  handleShowCarreraLookup = () => {
    this.setState({ showLookupCarreras: true });
  };

  handleDelete = (i) => {
    this.setState({ tagData: this.state.tagData.filter((tag) => tag.id !== i) });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-axc" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-add-axc">
        <Link className="md-page__back-link" to="/md-axc">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Inscribir alumno</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione un alumno existente, una o más carreras y el año de inicio en la carrera.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowStudentLookup}>
                  Seleccionar alumno
                </button>
              ) : null}
              <div className="md-page__picker-fields">
                <input
                  className="md-page__field-input"
                  disabled
                  value={this.state.alumno.alumnoDni}
                  placeholder="DNI del alumno"
                  readOnly
                />
                <input
                  className="md-page__field-input"
                  disabled
                  value={this.state.alumno.alumnoNombre}
                  placeholder="Nombre del alumno"
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Carreras</span>
            {!loading ? (
              <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                Seleccionar carrera
              </button>
            ) : null}
            {this.renderTags()}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Año de inicio en la carrera</span>
            <input
              className="md-page__field-input md-page__field-input--year"
              type="text"
              inputMode="numeric"
              maxLength={4}
              disabled={loading}
              value={this.state.anioInicio}
              onChange={this.handleAnioInicioChange}
              aria-label="Año de inicio en la carrera"
            />
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Guardar cambios
            </button>
          </div>
        </div>

        {this.state.showLookupStudent ? (
          <LookupAlumnos
            selectStudent={this.handleSelectStudentItem}
            hideLookup={this.handleHideStudentLookup}
          />
        ) : null}
        {this.state.showLookupCarreras ? (
          <LookupCarreras
            selectItem={this.handleSelectCarreraItem}
            hideLookup={this.handleHideCarreraLookup}
          />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    const tags = this.state.tagData.slice(1);
    return (
      String(this.state.alumno.alumnoCodigo || '').length > 0
      && tags.length > 0
      && isValidAnioInicioCarrera(this.state.anioInicio)
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await alumnoCarreraService.saveAlumnoCarrera(
        toSaveAlumnoCarreraPayload(
          this.state.tagData.slice(1),
          this.state.alumno.alumnoCodigo,
          this.state.anioInicio
        )
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyAlumnoCarreraError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage, showErrorMessage: true });
    }
  }
}
